// src/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyAD8lMSbGRzCfQ9hADyW3Fh3Fz3rlVoaTQ",
  authDomain: "empowerher-8b377.firebaseapp.com",
  projectId: "empowerher-8b377",
  storageBucket: "empowerher-8b377.firebasestorage.app",
  messagingSenderId: "291840814059",
  appId: "1:291840814059:web:ab075198ca41eaa75407ae",
  measurementId: "G-9J2GTVD2Y2"
};


const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export default db;
